export default __webpack_public_path__ + "static/media/Archdeacon's Armbands of the Eighteen Pits.f29f6cac.jpg";